/**
 * Dashboard-Karte der Belege (Paket 3): erscheint nur, wenn etwas zu tun ist –
 * Integritätsbefund (B6), Platzhalter-Aussteller im Live-Modus (W6), Klärfälle der
 * Belege (doppelte Erstattung W12, ungültiges Lieferland W3, …).
 */
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { belegHinweise } from '../api/belege';
import { datumZeit } from './format';
import { Karte } from './ui';

export function BelegHinweise() {
  const q = useQuery({ queryKey: ['beleg-hinweise'], queryFn: belegHinweise, refetchInterval: 60_000 });
  const h = q.data?.hinweise ?? [];
  if (!h.length) return null;
  const alarm = h.some((x) => x.schwere === 'alarm');
  return (
    <Karte titel={`Belege: ${h.length} Hinweis${h.length === 1 ? '' : 'e'}`} klasse={alarm ? 'alarm' : ''}>
      <ul data-testid="beleg-hinweise" style={{ margin: 0, paddingLeft: "1.2em" }}>
        {h.map((x, i) => (
          <li key={x.id ?? `${x.art}-${i}`} data-art={x.art}>
            <strong>{x.schwere === 'alarm' ? 'Alarm' : 'Hinweis'}:</strong> {x.text}
            {x.seit ? <span className="hinweis"> · seit {datumZeit(x.seit)}</span> : null}
            {x.link ? <> · <Link to={x.link}>ansehen</Link></> : null}
          </li>
        ))}
      </ul>
    </Karte>
  );
}
